import { render, staticRenderFns } from "./ProductLabelBulkAttachSku.vue?vue&type=template&id=5bc5be24&scoped=true&"
import script from "./ProductLabelBulkAttachSku.vue?vue&type=script&lang=js&"
export * from "./ProductLabelBulkAttachSku.vue?vue&type=script&lang=js&"
import style0 from "./ProductLabelBulkAttachSku.vue?vue&type=style&index=0&id=5bc5be24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc5be24",
  null
  
)

export default component.exports